export default __webpack_public_path__ + "static/media/goshen14.da0a9d10.jpg";